<!-- 
<div class="content-loading" *ngIf="DisplayText">
    <ng-container *ngIf="hasProjectedContent else DefaultContent">
        <ng-container *ngTemplateOutlet="ProjectedContent"></ng-container>
    </ng-container>
</div>

<ng-template #DefaultContent >
    <h1>{{DisplayText}}</h1>
    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/account-loading.gif"
        [attr.x-contenttype]="'image/gif'" alt="Loading..." />
    <h1 *ngIf="SubText">{{SubText}}</h1>
</ng-template> -->

@if (DisplayText) {
<div class="content-loading">

    @if (hasProjectedContent) {
    <ng-container *ngTemplateOutlet="ProjectedContent"></ng-container>
    }
    @else {
    <h1>{{ DisplayText }}</h1>

    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/account-loading.gif"
        [attr.x-contenttype]="'image/gif'" alt="Loading..." />

    @if (SubText) {
    <h1>{{ SubText }}</h1>
    }
    }

</div>
}